<template>
  <div>
    <!-- Corpo -->
    <div class="bg-white rounded-lg shadow-md p-6 mb-4">
      <div class="flex justify-center">
        <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
      </div>
    </div>
    <div class="bg-white rounded-lg shadow-md p-4 mb-4">
      <h1 class="text-center text-xl font-bold text-red-500">{{ contextualMessage }}</h1>
    </div>
    <form @submit.prevent="submitForm()">
      <div class="px-6 pb-0">
        <div class="grid grid-cols-2 bg-white rounded-md shadow-lg px-4 py-2">
          <div class="p-4">
            <div class="mb-4 pb-3">
              <input type="text" v-model="currentDateTime" class="p93__input" readonly />
            </div>
            <div class="grid grid-cols-2">
              <div class="p-0 pr-2">
                <div class="mb-4 pb-3">
                  <video id="webcam-preview" autoplay playsinline class="w-full max-w-md rounded-md shadow-lg border" style="transform: scaleX(-1)"></video>
                </div>
              </div>
              <div class="p-0 pl-2">
                <div class="mb-4 pb-3">
                  <QrcodeStream @detect="onDetect" class="w-full max-w-md hidden" />
                  <input id="barcode" type="text" v-model="form.badge" @input="searchVisitor" placeholder="Badge"
                    :class="['p93__input', { 'pulse-red-border': shouldHighlightBadge }]" required />
                  <div v-if="!badgeIsActive && form.badge" class="text-red-500 text-sm pt-2">Badge non valido o scaduto</div>
                  <div v-if="!badgeExists && form.badge" class="text-red-500 text-sm pt-2">Badge non trovato</div>
                  <div v-if="form.errors.badge" class="text-red-500 text-sm pt-2">{{ form.errors.badge }}</div>
                  <video id="barcode-scanner" class="hidden"></video>
                </div>
                <div class="mb-4 pb-3">
                  <input type="text" v-model="form.name" class="p93__input" placeholder="Nominativo" required disabled="disabled" />
                  <div v-if="form.errors.name" class="text-red-500 text-sm pt-2">{{ form.errors.name }}</div>
                </div>
                <div class="mb-4 pb-3">
                  <input type="text" v-model="form.company" class="p93__input" placeholder="Azienda" required disabled="disabled" />
                  <div v-if="form.errors.company" class="text-red-500 text-sm pt-2">{{ form.errors.company }}</div>
                </div>
              </div>
            </div>
            <div class="mb-4 pb-2">
              <input type="text" :value="selectedContact?.name" class="p93__input" required disabled="disabled" />
            </div>
          </div>
          <div class="p-4">
            <div class="mb-4">
              <label class="font-bold">Firma:</label>
              
              <div class="rounded-md shadow-lg border mt-2" style="width: 100%; height: 145px; display: flex; align-items: center; justify-content: center; background-color: #f9f9f9;">
                <img v-if="signature" :src="signature" alt="Firma" class="max-w-full max-h-full object-contain" />
                <span v-else class="text-gray-500">Nessuna firma disponibile</span>
              </div>
              <div v-if="signatureError" class="text-red-500 text-sm pt-2">Firma necessaria!</div>
              <div v-if="form.errors.signature" class="text-red-500 text-sm pt-2">{{ form.errors.signature }}</div>
              <div class="flex justify-between mt-5">
                <Link :href="route('modules.home', { slug: 'reception-digitale' })"
                  class="bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-md flex items-center border">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                  </svg>
                  Torna indietro
                </Link>
                <button type="submit"
                  class="bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-4 py-2 rounded-md flex items-center" :disabled="isSubmitting">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Registra uscita
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <ModalMessage
      v-if="showCheckin"
      :visible="showCheckin"
      title="Ingresso registrato con successo!"
      :messages="['Ricordati di registrare il badge in uscita.', 'Buona permanenza!']"
      @close="resetForm"
    />
    <ModalMessage
      v-if="showCheckout"
      :visible="showCheckout"
      title="Uscita Registrata con successo!"
      :messages="[
        `La tua visita è durata ${visitDuration}.`,
        'Ci auguriamo che la permanenza sia stata piacevole!'
      ]"
      @close="backHome"
    />
  </div>
</template>

<script>
import { Link, useForm, usePage, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import { format } from 'date-fns';
import { QrcodeStream } from 'vue-qrcode-reader';
import ModalMessage from '@/Components/ModalMessage.vue';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';

export default {
  props: ['errors', 'visitor', 'badge', 'badgeIsActive', 'badgeExists', 'visit', 'selectedContact', 'signature', 'badgeVisitError'],
  components: {
    Link,
    BreadCrumbs,
    QrcodeStream,
    ModalMessage
  },
  layout: LayoutNoHeader,
  data() {
    return {
      form: useForm({
        date_time: null,
        name: null,
        company: null,
        badge: null,
        contact_id: null,
        contact: null,
        signature: null
      }),
      currentDateTime: '',
      dateFormat: 'yyyy-MM-dd',
      searchContactBy: null,
      signatureError: false,
      showCheckin: false,
      showCheckout: false,
      visitDuration: null,
      barcode: null,
      isSubmitting: false,
    };
  },
  computed: {
    contextualMessage() {
      // Check for error states first
      if (!this.badgeIsActive && this.form.badge) {
        return "Badge non valido o scaduto. Contattare la reception.";
      }
      
      if (!this.badgeExists && this.form.badge) {
        return "Badge non trovato. Verificare il codice o contattare la reception.";
      }

      if (this.badgeVisitError) {
        return "Nessuna visita associata a questo badge.";
      }

      if (this.visitor && this.form.badge && !this.selectedContact) {
        return "Inserire il referente del proprio appuntamento";
      }

      // Check for badge scanned but no visitor
      if (this.form.badge) {
        return "Badge riconosciuto";
      }
      
      return "Prego mostrare alla telecamera il badge ritirato in precedenza";
    },
    shouldHighlightBadge() {
      return !this.form.badge;
    }
  },
  mounted() {
    const page = usePage();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.startWebcam(); // Start the webcam feed
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDateTime = format(now, 'dd/MM/yyyy HH:mm:ss');
      this.form.date_time = now.toISOString();
    },
    submitForm() {
      this.isSubmitting = true;
      this.form.contact_id = (this.form.contact_id === null || this.form.contact_id === undefined) ? this.form.contact?.id : this.form.contact_id;
      this.form.post(route('modules.rd-nuovo-registro-uscita'), {
        only: ['visit'],
        preserveState: true,
        preserveScroll: true,
        replace: true,
        onSuccess: (page) => {
            const durationInMinutes = page.props.visit.duration;
            const hours = Math.floor(durationInMinutes / 60);
            const minutes = durationInMinutes % 60;
            this.visitDuration = `${hours} ore e ${minutes} minuti`;
            this.showCheckout = true;
        },
        onFinish: () => {
          this.isSubmitting = false;
        }
      });
    },
    setVisitorData(visitor) {
      this.form.name = visitor?.name;
      this.form.company = visitor?.company;
    },
    setContactData(contact) {
      this.form.contact_id = contact?.id;
    },
    searchVisitor() {
      if (this.form.badge.length >= 3) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          router.get(route('modules.rd-uscita'), {
            badge: this.form.badge,
            search: this.searchVisitorBy
          }, {
            preserveState: true,
            only: ['visitor', 'badgeIsActive', 'badgeExists', 'selectedContact', 'signature', 'badgeVisitError'],
            onSuccess: (page) => {
              if (page.props.badgeVisitError) {
                this.form.badge = '';
              } else {
                this.setVisitorData(page.props.visitor);
                this.setContactData(page.props.selectedContact);
              }
            }
          });
        }, 300);
      }
    },
    resetForm() {
      router.get(route('modules.rd-uscita'));
    },
    onDetect(codes) {
      if (codes.length > 0) {
        this.form.badge = codes[0].rawValue; // Popola il campo con il valore scansionato
        this.searchVisitor();
      }
    },
    startWebcam() {
      const videoElement = document.getElementById('webcam-preview');
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true })
          .then((stream) => {
            videoElement.srcObject = stream;
          })
          .catch((error) => {
            console.error('Error accessing webcam:', error);
          });
      }
    },
    backHome() {
      router.visit(route('modules.home', { slug: 'reception-digitale' }));
    },
  },
  watch: {
    visitor(value) {
      this.form.name = value?.name;
      this.form.company = value?.company;
    }
  }
};
</script>

<style scoped>
.pulse-red-border {
  animation: pulseRedBorder 2s infinite;
  border: 2px solid #ef4444 !important;
}

@keyframes pulseRedBorder {
  0% {
    border-color: #ef4444;
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
  }
  50% {
    border-color: #dc2626;
    box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
  }
  100% {
    border-color: #ef4444;
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
}
</style>